<template>
    <div>
            <b-skeleton-img v-if="status"></b-skeleton-img>
            <div v-else v-html="content.text"></div>
    </div>
</template>
<script>
export default {
    // ارسال درخواست برای دریافت محتویات صفحه قبل از ساخت کامپوننت
    beforeCreate(){
        this.$store.dispatch("front/getPageFromServer",this.$route.params.page)
    },
    computed:{
        content(){
            return this.$store.getters["front/getPageContent"];
        },
        status(){
            return this.$store.getters["front/getPageContentStatus"];
        }
    },
    
}
</script>